export default __webpack_public_path__ + "static/media/elec.d9f83221.png";